/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getNutritionists } from 'app/entities/nutritionist/nutritionist.reducer';
import { getEntities as getTreatmentPlans } from 'app/entities/treatment-plan/treatment-plan.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { MealType } from 'app/shared/model/enumerations/meal-type.model';
import { MealStatus } from 'app/shared/model/enumerations/meal-status.model';
import { OrderStatus } from 'app/shared/model/enumerations/order-status.model';
import { FeedType } from 'app/shared/model/enumerations/feed-type.model';
import { EntralType } from 'app/shared/model/enumerations/entral-type.model';
import { createEntity, getEntity, reset, updateEntity } from './nutrition-order.reducer';

export const NutritionOrderUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const nutritionists = useAppSelector(state => state.nutritionist.entities);
  const treatmentPlans = useAppSelector(state => state.treatmentPlan.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const nutritionOrderEntity = useAppSelector(state => state.nutritionOrder.entity);
  const loading = useAppSelector(state => state.nutritionOrder.loading);
  const updating = useAppSelector(state => state.nutritionOrder.updating);
  const updateSuccess = useAppSelector(state => state.nutritionOrder.updateSuccess);
  const mealTypeValues = Object.keys(MealType);
  const mealStatusValues = Object.keys(MealStatus);
  const orderStatusValues = Object.keys(OrderStatus);
  const feedTypeValues = Object.keys(FeedType);
  const entralTypeValues = Object.keys(EntralType);

  const handleClose = () => {
    navigate(`/nutrition-order${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getNutritionists({}));
    dispatch(getTreatmentPlans({}));
    dispatch(getDoctors({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...nutritionOrderEntity,
      ...values,
      fulfilledBy: nutritionists.find(it => it.id.toString() === values.fulfilledBy?.toString()),
      treatmentPlan: treatmentPlans.find(it => it.id.toString() === values.treatmentPlan?.toString()),
      createdBy: doctors.find(it => it.id.toString() === values.createdBy?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          mealType: 'BEFORE_BREAKFAST',
          mealStatus: 'PLANNED',
          orderStatus: 'CREATED',
          feedType: 'ENTERAL',
          entralType: 'GENRAL',
          ...nutritionOrderEntity,
          fulfilledBy: nutritionOrderEntity?.fulfilledBy?.id,
          treatmentPlan: nutritionOrderEntity?.treatmentPlan?.id,
          createdBy: nutritionOrderEntity?.createdBy?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.nutritionOrder.home.createOrEditLabel" data-cy="NutritionOrderCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.nutritionOrder.home.createOrEditLabel">Create or edit a NutritionOrder</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="nutrition-order-id"
                  label={translate('tinyMedicRestApp.nutritionOrder.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.nutritionOrder.microSec')}
                id="nutrition-order-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nutritionOrder.timestampentry')}
                id="nutrition-order-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nutritionOrder.lastupdated')}
                id="nutrition-order-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nutritionOrder.cursor')}
                id="nutrition-order-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nutritionOrder.active')}
                id="nutrition-order-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nutritionOrder.recomendation')}
                id="nutrition-order-recomendation"
                name="recomendation"
                data-cy="recomendation"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nutritionOrder.mealType')}
                id="nutrition-order-mealType"
                name="mealType"
                data-cy="mealType"
                type="select"
              >
                {mealTypeValues.map(mealType => (
                  <option value={mealType} key={mealType}>
                    {translate(`tinyMedicRestApp.MealType.${mealType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.nutritionOrder.mealStatus')}
                id="nutrition-order-mealStatus"
                name="mealStatus"
                data-cy="mealStatus"
                type="select"
              >
                {mealStatusValues.map(mealStatus => (
                  <option value={mealStatus} key={mealStatus}>
                    {translate(`tinyMedicRestApp.MealStatus.${mealStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.nutritionOrder.orderStatus')}
                id="nutrition-order-orderStatus"
                name="orderStatus"
                data-cy="orderStatus"
                type="select"
              >
                {orderStatusValues.map(orderStatus => (
                  <option value={orderStatus} key={orderStatus}>
                    {translate(`tinyMedicRestApp.OrderStatus.${orderStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.nutritionOrder.feedType')}
                id="nutrition-order-feedType"
                name="feedType"
                data-cy="feedType"
                type="select"
              >
                {feedTypeValues.map(feedType => (
                  <option value={feedType} key={feedType}>
                    {translate(`tinyMedicRestApp.FeedType.${feedType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.nutritionOrder.entralType')}
                id="nutrition-order-entralType"
                name="entralType"
                data-cy="entralType"
                type="select"
              >
                {entralTypeValues.map(entralType => (
                  <option value={entralType} key={entralType}>
                    {translate(`tinyMedicRestApp.EntralType.${entralType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="nutrition-order-fulfilledBy"
                name="fulfilledBy"
                data-cy="fulfilledBy"
                label={translate('tinyMedicRestApp.nutritionOrder.fulfilledBy')}
                type="select"
              >
                <option value="" key="0" />
                {nutritionists
                  ? nutritionists.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="nutrition-order-treatmentPlan"
                name="treatmentPlan"
                data-cy="treatmentPlan"
                label={translate('tinyMedicRestApp.nutritionOrder.treatmentPlan')}
                type="select"
                required
              >
                <option value="" key="0" />
                {treatmentPlans
                  ? treatmentPlans.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="nutrition-order-createdBy"
                name="createdBy"
                data-cy="createdBy"
                label={translate('tinyMedicRestApp.nutritionOrder.createdBy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/nutrition-order" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default NutritionOrderUpdate;
